/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'GoalPanel.header.title': 'ゴール',
  'goal-panel.generic-error.description': '接続を確認してもう一度お試しください。',
  'goal-panel.generic-error.title': '問題が発生しました',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'さらにフィールドを表示',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': '表示を減らす',
  'goal-panel.goal-panel-tabs.about-tab-title': '概要',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'プロジェクト',
  'goal-panel.goal-panel-tabs.updates-tab-title': '最新情報',
  'goal-panel.goal-title.edit-button-label': 'ゴール タイトルを編集',
  'goal-panel.goal-title.update-error-description': '{goalName} のコンテンツを更新できませんでした',
  'goal-panel.goal-title.update-error-title': '問題が発生しました',
  'goal-panel.goal-title.validation-message': 'ゴールのタイトルを指定してください',
};
